import { CircularProgress, Typography } from "@mui/material";
import projectLogo from "../../assets/brand_logo_white.png";
import "../Login/Login.css";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSnackbar } from "../../context/SnackbarContext";
import axios from "axios";
import passwordIcon from "../../assets/login_password.svg";

// import axios from "axios";
// import { baseUrl } from "../Utils/common";
// import { useSnackbar } from "../../context/SnackbarContext";

const OtpPage = () => {
  //   const [Otp, setOtp] = useState(null);
  //   const { showSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  // const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const [, setValidPassword] = useState(true);
  const { showSnackbar } = useSnackbar();

  useEffect(() => {
    setPasswordsMatch(true);
    setValidPassword(true);
  }, []);

  const handleReset = async (e: any, newPassword: string) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (!newPassword) {
        showSnackbar("Please enter a new password", "error");
        return;
      }

      if (!confirmPassword) {
        showSnackbar("Please confirm the new password", "error");
        return;
      }

      if (newPassword !== confirmPassword) {
        showSnackbar("Passwords do not match", "error");
        return;
      }

      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
      if (!passwordRegex.test(newPassword)) {
        showSnackbar(
          "Password must contain at least one uppercase letter, one lowercase letter, one number, and be at least 8 characters long",
          "error"
        );
        return;
      }
      const email = "suhail@veehive.ai";
      const otp = 1234;

      const response = await axios.post(
        `${import.meta.env.VITE_BASE_URL}/clients/user/reset-password`,
        { email: email, newPassword: newPassword, otp: otp }
      );

      if (response.data.statusCode === "OK") {
        setNewPassword(newPassword);
        showSnackbar(response.data.responseInfo.description, "success");
        navigate("/login");
        // navigate("/");
      } else {
        showSnackbar(response.data.responseInfo.description, "error");
        setNewPassword("");
        setConfirmPassword("");
      }
    } catch (error) {
      console.error("Error during password reset:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress />{" "}
        </div>
      ) : (
        <div className="login_content_wrapper">
          <div className="login_body_wrapper">
            <div className="login_content_holder">
              <img src={projectLogo} alt="logo" className="login_brand_logo" />
              <h1 className="white_text">The Platform for Emiratis</h1>
            </div>
          </div>
          <div className="login_form_wrapper_ak">
            <div className="login">
              <div className="login-form-container">
                <h2>Verification</h2>
                <p className="gray_text">Please enter the OTP you received.</p>

                <form className="login-form">
                  <div className="ak_login_input_wrapper">
                    <img src={passwordIcon} alt="email_icon" />
                    <input
                      className="ak_login_input"
                      type="email"
                      id="email"
                      placeholder="OTP"
                    />
                  </div>

                  <br />

                  <div className="ak_login_input_wrapper">
                    <img src={passwordIcon} alt="email_icon" />
                    <input
                      className="ak_login_input"
                      type="email"
                      id="email"
                      placeholder="New Password"
                    />
                  </div>
                  {/* <div className="input-container">
                    <label htmlFor="email" className="label">
                      New Password
                    </label>
                    <TextField
                      type="password"
                      id="password"
                      placeholder="New Password"
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                    />
                  </div> */}
                  <br />
                  <div className="ak_login_input_wrapper">
                    <img src={passwordIcon} alt="email_icon" />
                    <input
                      className="ak_login_input"
                      type="email"
                      id="email"
                      placeholder="Confirm Password"
                    />
                  </div>
                  {/* <div className="input-container">
                    <label htmlFor="email" className="label">
                      Confirm Password
                    </label>
                    <TextField
                      type="password"
                      id="password"
                      placeholder="Confirm Password"
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    {!passwordsMatch && (
                      <Typography sx={{ color: "red", fontSize: "12px" }}>
                        Passwords do not match.
                      </Typography>
                    )}
                    {!validPassword && (
                      <Typography sx={{ color: "red", fontSize: "12px" }}>
                        Password must be at least 8 characters long and contain
                        at least one number and one special character.
                      </Typography>
                    )}
                  </div> */}
                  {!passwordsMatch && (
                    <Typography
                      sx={{ color: "red", fontSize: "12px", mt: "3%" }}
                    >
                      New Password and Confirm Password must match.
                    </Typography>
                  )}

                  <div className="submit-container">
                    <button
                      className="submit-button"
                      onClick={(e) => handleReset(e, newPassword)}
                    >
                      Reset Password
                    </button>
                  </div>
                  <Link to={`/login`} style={{ textDecoration: "none" }}>
                    <div className="backarrow-container">
                      {/* <div>
                        <img
                          src={backArrow}
                          alt="img"
                          style={{ height: "10px", marginRight: "8px" }}
                        />
                      </div> */}
                      <h1 className="forgot-label">Back to Sign In</h1>
                    </div>
                  </Link>
                </form>
              </div>
              {/* {error && <p className="error-message">{error}</p>} */}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OtpPage;
